



















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { PageModeType } from '../../types';

@Component({})
export default class SubPage extends Vue {
    @Prop({ default: 'main_page' }) pageMode!: PageModeType
    @Prop({ default: () => { } }) onSwitchMode!: (mode: PageModeType) => void

    @Watch('pageMode')
    watchPageMode(){
        window.scroll({ top: 0, behavior: "smooth" })
    }
}
